import React, { useEffect, useState } from 'react';

const imageOptions = [
  "/images/logo1.png",
  "/images/logo2.png",
  "/images/logo3.png",
];

export default function AboutPage() {
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * imageOptions.length);
    setSelectedImage(imageOptions[randomIndex]);
  }, []);

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: 'auto' }}>
      <h1>About uncanNy valley</h1>
      <h2>A game to welcome our future A.I. overlords</h2>
      <h2>by barry joseph</h2>
      {selectedImage && (
        <img
          src={selectedImage}
          alt="UncanNy Valley"
          style={{ width: '50%', borderRadius: '8px', margin: '20px auto', display: 'block' }}
        />
      )}

      <p>Uncannny Valley is a quick game using a unique set of cards that serve as guides for players to journey through the uncanny valley produced when computers try to reproduce the world around us. It is both an art game (an experience designed to raise provocative questions rather than promote a particular set of answers) and a game for change (an experience designed with particular social impact goals and educational outcomes in mind). 
      </p>
      <p>The physical card game was created in the fall of 2023 and the winter of 2024. There are 6 categories and each category is composed of 5 elements.
      </p>
      <p>
      The cards are unique for 3 reasons:
      </p>
      <p>
      1. Like the game of Spot It! each card is a collection of distinct and random visual elements with only one matching element shared between any two cards (e.g., a cat, a bicycle). It’s like a magic trick, performed through math (<a href="https://en.wikipedia.org/wiki/Combinatorics">combinatorics</a>). Uncannny Valley, however, is often played combining two decks, which means between any two cards only one element is shared in common or ALL elements are shared. 
      </p>
      <p>
      2. Like the game of Dixit, the elements on each card are arranged into an evocative scene suggesting a story, one to be interpreted by the players (e.g. why is that pirate a cat? And driving a car?). In Uncannny Valley, however, there is a fixed meaning (e.g. that is definitely a cat pirate, and it is most certainly driving a car). 
      </p>
      <p>
      3. All of the art on the cards were produced through Midjourney, a publicly-accessible A.I. that generates images from text prompts. Many use a tool like this to create a base image then adjust or correct them in other tools; Uncannny Valley, however, uses images with no post-processing, leaving all the flaws in place. The art was created with a human, and were selected by a human, but the final output is pure A.I.
        </p>
        <p>
      The physical cards afford a wide range of games - collaborative, whimsical games; rapid-fire, card grabbing games; strategic trick-taking games. At the same time, Uncannny Valley provides both an opportunity to marvel at the wonders that can be produced when working in tandem with contemporary A.I.s while developing literacies to address the biases, ethical conundrums, and other dangers involved. 
      </p>
      <p>To get your own copy of the cards, go <a href="https://docs.google.com/forms/d/e/1FAIpQLSe4AaL9w5dNvE9OICSSnR5_xACL_ZjuWNhUEWqD-uiIrE50Fg/viewform">here</a>. You can also learn more on <a href="https://www.instagram.com/uncannnyvalleygame/">Instagram</a>.
        </p>
      <p>In June 0f 2025, MidJourney added video production capabilities. Using the original cards for the game, MidJourney turned the assets from the physical deck into content for a digital game. Using ChatGPT's coding tools, the beta for the entire game was developed and launched in ten days.  
      </p>
      <p>If you would like to make your own deck of card for me to add to the game, hit me up on <a href="https://docs.google.com/forms/d/e/1FAIpQLSe4AaL9w5dNvE9OICSSnR5_xACL_ZjuWNhUEWqD-uiIrE50Fg/viewform">Insta</a>. I can share the spreadsheet tool with you.</p>
      <p><b>What will you see today?</b></p>







    </div>
  );
}
